import { Injectable } from '@angular/core'
import { HttpService } from '@lla-platform/core/core-data-access'
import { Observable } from 'rxjs'
import { EVENTS_CALENDAR_API_URL } from './events-calendar-api-routes'
import {
  ICalendarEventByFormResponse,
  ICalendarEventItem,
  IGetCalendarEventsRequest,
  IGetCalendarEventsResponse,
  IGetCalendarUsersResponse,
  IGetTasksRequest,
  IGetTasksResponse,
  ITaskListItem,
  IUpsertCalendarEventRequest,
  IUpsertTaskRequest
} from '../interfaces/events-calendar.interface'
import { CalendarInspectionType } from '../enums/events-calendar.enum'

@Injectable({
  providedIn: 'root'
})
export class EventsCalendarService {
  constructor(private http: HttpService) {}

  getCalendarUsers(): Observable<IGetCalendarUsersResponse> {
    return this.http.get(EVENTS_CALENDAR_API_URL.users)
  }

  getCalendarEvents(payload: IGetCalendarEventsRequest): Observable<IGetCalendarEventsResponse> {
    return this.http.post(EVENTS_CALENDAR_API_URL.list, payload)
  }

  getTasks(payload: IGetTasksRequest): Observable<IGetTasksResponse> {
    return this.http.post(EVENTS_CALENDAR_API_URL.tasksList, payload)
  }

  createTask(payload: IUpsertTaskRequest): Observable<ITaskListItem> {
    return this.http.post(EVENTS_CALENDAR_API_URL.taskCreate, payload)
  }

  updateTask(taskId: string, payload: IUpsertTaskRequest): Observable<ITaskListItem> {
    return this.http.put(EVENTS_CALENDAR_API_URL.taskUpdate(taskId), payload)
  }

  createCalendarEvent(payload: IUpsertCalendarEventRequest): Observable<ICalendarEventItem> {
    return this.http.post(EVENTS_CALENDAR_API_URL.create, payload)
  }

  updateCalendarEvent(
    eventId: string,
    payload: IUpsertCalendarEventRequest
  ): Observable<ICalendarEventItem> {
    return this.http.put(EVENTS_CALENDAR_API_URL.update(eventId), payload)
  }

  deleteCalendarEvent(eventId: string): Observable<void> {
    return this.http.delete(EVENTS_CALENDAR_API_URL.delete(eventId))
  }

  updateTaskStatus(taskId: string, isCompleted: boolean): Observable<void> {
    return this.http.put(EVENTS_CALENDAR_API_URL.taskStatus(taskId), { isCompleted })
  }

  deleteTask(taskId: string): Observable<void> {
    return this.http.delete(EVENTS_CALENDAR_API_URL.taskDelete(taskId))
  }

  linkInspectionForm(
    eventId: string,
    inspectionType: CalendarInspectionType,
    formId: string
  ): Observable<void> {
    return this.http.put(EVENTS_CALENDAR_API_URL.inspectionForm(eventId, inspectionType), { formId })
  }

  getEventByForm(formId: string): Observable<ICalendarEventByFormResponse> {
    return this.http.get(EVENTS_CALENDAR_API_URL.byForm(formId))
  }
}
